module.exports = __webpack_public_path__ + "static/media/italy_heatmap.8d5c75ed.png";